import { Controller } from "stimulus";

export default class extends Controller {
  activeBoxClass = 'active-box';

  connect() {
    this.initialize();
    if (this.element.dataset.name)
      this.element.setAttribute('name', this.element.dataset.name);

    if (this.isSimple()) {
      let selectedItem = this.element.querySelector('.dropdown-menu .dropdown-item.selected');

      if (!selectedItem)
        selectedItem = this.element.querySelector('.dropdown-menu .dropdown-item');

      this.change(selectedItem, false);
    } else {
      this.updateTargetInputValues();
    }

    this.listenAttributeChange();
    this.element.querySelectorAll('.dropdown-item[data-value]').forEach(($el) => {
      $el.addEventListener('click', (ev) => {
        if(!$el.dataset.turboFrame)
          ev.preventDefault();

        this.change($el);
      });
    });

    if (!this.isSimple()) {
      this.element.querySelectorAll('.dropdown-item[data-select-all]').forEach(($el) => {
        $el.addEventListener('click', (ev) => {
          ev.preventDefault();
          this.toggleSelectAll();
        });
      });
    }
  }

  toggleSelectAll() {
    const items = this.element.querySelectorAll('.dropdown-item[data-value]');
    if (items.length === 0) return;

    const allSelected = Array.from(items).every(($it) => $it.classList.contains('selected'));
    items.forEach(($it) => $it.classList.toggle('selected', !allSelected));
    this.updateTargetInputValues();
    this.element.dispatchEvent(new Event('change'));
  }

  initialize() {
    this.element.selectedOptions = [];
    this.id = new Date().getDate();
  }

  listenAttributeChange() {
    let mutation = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === 'value') {
          this.element.querySelectorAll('.dropdown-item[data-value]').forEach(($el) => {
            if ($el.dataset.value === this.element.getAttribute('value')) {
              return this.change($el, false);
            }
          })
        }
      });
    });
    mutation.observe(this.element, {
      attributes: true
    })
  }

  updateTargetInputValues() {
    this.element.selectedOptions = this.element.querySelectorAll('.dropdown-item.selected');
    this.element.value = [...this.element.selectedOptions];

    if (!this.element.dataset.name)
      return;

    if (this.isSimple())
      return this.updateSingleInputValue();

    this.updateMultipleInputsValues();
  }

  isSimple() {
    return !this.element.dataset.multiple;
  }

  updateSingleInputValue() {
    let $input = document.querySelector(`input[name="${this.element.dataset.name}"]`);

    if (!$input) {
      this.getTarget().insertAdjacentHTML('beforebegin', `<input name="${this.element.dataset.name}" type="hidden" value="${this.element.selectedOptions[0].dataset.value}" />`);
      $input = document.querySelector(`[name="${this.element.dataset.name}"]`);
    }

    $input.value = this.element.selectedOptions[0].dataset.value;
  }

  updateMultipleInputsValues() {
    let wrapperClass = `dropdown-select-input-wrapper-${this.id}`,
      $wrapper = document.querySelector(`.${wrapperClass}`);

    if (!$wrapper) {
      this.getTarget().insertAdjacentHTML('afterbegin', `<div class="${wrapperClass} d-none"></div>`);
      $wrapper = document.querySelector(`.${wrapperClass}`);
    }

    $wrapper.innerHTML = '';
    this.element.selectedOptions.forEach(($it) => {
      $wrapper.insertAdjacentHTML('beforeend', `<input name="${this.element.dataset.name}" type="hidden" value="${$it.dataset.value}" />`);
    });
  }

  getTarget() {
    return !!this.element.dataset.elementTarget ? document.querySelector(this.element.dataset.elementTarget) : this.element.parentElement;
  }

  change($selectedElement, emitEvent = true) {
    if (!$selectedElement)
      return;

    this.updateSelectedItems($selectedElement);
    this.updateTargetInputValues();

    let dropdownToggle = this.element.querySelector('.dropdown-toggle[role="button"] .text');
    if (!!dropdownToggle)
      dropdownToggle.innerHTML = !!$selectedElement.dataset.text ? $selectedElement.dataset.text.replaceAll('\\"', '"') : $selectedElement.innerHTML;

    this.updateSelectedIcon($selectedElement);

    if (!!emitEvent)
      this.element.dispatchEvent(new Event('change'));
  }

  // Opt-in: when the chip has a `.js-selected-icon` slot and the selected item a
  // `.js-item-icon`, mirror the item's icon into the chip so it reflects the choice.
  updateSelectedIcon($selectedElement) {
    let $chipIcon = this.element.querySelector('.js-selected-icon');
    let $itemIcon = $selectedElement.querySelector('.js-item-icon');

    if (!!$chipIcon && !!$itemIcon)
      $chipIcon.innerHTML = $itemIcon.innerHTML;
  }

  updateSelectedItems($selectedElement) {
    if (this.isSimple()) {
      this.element.querySelectorAll('.dropdown-menu .dropdown-item').forEach(($li) => $li.classList.remove('selected'));
      return $selectedElement.classList.add('selected');
    }

    $selectedElement.classList.toggle('selected');
  }
};